import MediaInvestorTypeEnum from '@constants/enums/media/investor/type';
import MediaTypeEnum from '@constants/enums/media/type';
import QuarantineStatusEnum from '@constants/enums/quarantineStatus';

import MediaInvestorApi from '@packages/media/investor/api';

import { Media, Investor, Adviser, Holding, Transaction, Product, Fund, Tranche, Provider } from '@/models';

export class MediaInvestor extends Media {
    static name = 'MediaInvestor';
    static entity = 'mediaInvestor';
    static Api = MediaInvestorApi;

    static fields() {
        return {
            ...super.fields(),
            type: this.enum(MediaInvestorTypeEnum),
            library_type: this.string(MediaTypeEnum.INVESTOR),
            document_date: this.string(null).nullable(),
            quarantine_status: this.enum(QuarantineStatusEnum).nullable(),

            adviser_id: this.string(null).nullable(),
            adviser: this.belongsTo(Adviser, 'adviser_id'),

            investor_id: this.string(null).nullable(),
            investor: this.belongsTo(Investor, 'investor_id'),

            holding_id: this.string(null).nullable(),
            holding: this.belongsTo(Holding, 'holding_id'),

            transaction_id: this.string(null).nullable(),
            transaction: this.belongsTo(Transaction, 'transaction_id'),

            product_id: this.string(null).nullable(),
            product: this.belongsTo(Product, 'product_id'),

            fund_id: this.string(null).nullable(),
            fund: this.belongsTo(Fund, 'fund_id'),

            tranche_id: this.string(null).nullable(),
            tranche: this.belongsTo(Tranche, 'tranche_id'),

            provider_id: this.string(null).nullable(),
            provider: this.belongsTo(Provider, 'provider_id')
        };
    }

    get is_published() {
        return this.quarantine_status === QuarantineStatusEnum.PUBLISHED;
    }

    get is_quarantined() {
        return !this.is_published;
    }

    get file_name_format_options() {
        const options = super.file_name_format_options;

        const replacements = options.replacements || [];

        replacements.push({
            find: /^GIIV\d+_/,
            replace: ''
        });

        options.replacements = replacements;

        return options;
    }
}

export default MediaInvestor;
